"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initialState() {
  return {
    // Property
    propertyExpenses: [{
      mortgageRent: 0,
      propertyTaxes: 0,
      propertyInsurance: 0,
      upkeepRepairs: 0,
      hoaCondoFees: 0,
      additionalPayments: 0
    }],
    // Utilities/Bills
    electric: 0,
    heat: 0,
    waterSewerTrash: 0,
    cablePhoneInternet: 0,
    cellPhone: 0,
    otherUtilities: [],
    // [{ name: null, value: 0 }]
    // Personal
    groceries: 0,
    personalCare: 0,
    hairCuts: 0,
    cleaningLaundry: 0,
    clothing: 0,
    recreation: 0,
    // Medical
    medicalExpenses: 0,
    medicalPrescriptions: 0,
    dentalExpenses: 0,
    dentalPrescriptions: 0,
    visionExpenses: 0,
    glasses: 0,
    contacts: 0,
    otherInsurance: [],
    // [{ name: null, value: 0 }] - Not deducted from paycheck
    lifeInsurance: 0,
    healthInsurance: 0,
    taxPayments: [],
    // [{ name: null, value: 0 }] - Not deducted from paycheck
    // Vehicles
    vehicleInsurance: 0,
    gasoline: 0,
    vehicleMaintenance: 0,
    otherTransportation: 0,
    // Family
    daycareBabysitter: 0,
    childEducation: 0,
    otherAlimony: [],
    contributionsToFamily: [],
    // [{ name: null, value: 0 }]
    // disabledFamily: 0,
    charity: 0,
    // Extras
    installmentPayments: [],
    // [{ name: null, value: 0 }]
    others: []
  };
}

;

var createExpenses = function createExpenses() {
  return _objectSpread(_objectSpread({}, initialState()), {}, {
    id: (0, _v["default"])()
  });
};

var _default = createExpenses;
exports["default"] = _default;